module.exports = __webpack_public_path__ + "static/img/7-5.43fcc43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/7-5.png
// module id = Se0e
// module chunks = 25